import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

interface NavigationLinkProps {
    icon: React.ReactNode;
    href: string;
    text: string;
}

const NavigationLink: React.FC<NavigationLinkProps> = ({
    icon,
    text,
    href,
}) => {
    return (
        <ListItemButton
            component="a"
            rel="noopener"
            target="_blank"
            href={href}
        >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText>{text}</ListItemText>
        </ListItemButton>
    );
};

export default NavigationLink;
